export default () => ({
  isDraftsFetched: false,
  drafts: [],
  isPublishing: false,
  publishReviewId: null,
  currentlyPublishingDrafts: [],
  shouldAnimateReviewButton: false,
  isMergeRequest: false,
});
